import(/* webpackMode: "eager" */ "/codebuild/output/src2466465509/src/apps/pickuji/src/components/layouts/PageHeader/PageHeader.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src2466465509/src/apps/pickuji/src/components/ui/Pagination/Pagination.tsx");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src2466465509/src/apps/pickuji/src/features/article/components/ArticleSmallList/ArticleSmallList.module.scss");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src2466465509/src/apps/pickuji/src/components/ui/ImageView/ImageView.module.scss");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src2466465509/src/node_modules/next/dist/client/link.js");
